import { render, staticRenderFns } from "./informative-list.vue?vue&type=template&id=ecb648c0&scoped=true"
import script from "./informative-list.vue?vue&type=script&lang=js"
export * from "./informative-list.vue?vue&type=script&lang=js"
import style0 from "./informative-list.vue?vue&type=style&index=0&id=ecb648c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb648c0",
  null
  
)

export default component.exports